import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";
import { env } from "../../env/env";
import { canManageItemLibraries, hasDataKitBeta } from "../account/page/data-kit/dataKitAccess";

/**
 * What `/menu-data` is for now (Oct 9): account admins go straight to Item Libraries management -
 * the way the Brand tab takes them to brand management - and everyone else back to the dashboard.
 *
 * The location Menu Data page (DataKitMenuDataPage) is parked rather than deleted: location price
 * editing for operators is paused until their editing workflow, with approvals, is designed. Until
 * then an operator landing there saw a page they couldn't edit and took it for broken.
 */
export function DataKitMenuDataRedirect() {
  const member = useRecoilValue(memberState);
  const toLibraries = hasDataKitBeta(member) && canManageItemLibraries(member);
  return <Navigate replace to={toLibraries ? `${env.dashboardPath}/account/data-kits` : `${env.dashboardPath}/designs`} />;
}
